import React from "react";
import "./Navigation.css";
import { Nav, Navbar } from "react-bootstrap";

const Navigation = () => {
  return (
    <div>
      <Navbar variant="dark" className="font" expand="md">
        <Navbar.Brand href="#home" className="navbar-heading  mx-md-3 mx-none">
          Mariam.
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav ">
          <Nav className="ms-auto">
            <Nav.Link href="#about" className="navbar-others">
              About
            </Nav.Link>
            <Nav.Link className="navbar-others" href="#skills">
              Skills
            </Nav.Link>
            <Nav.Link className="navbar-others" href="#experience">
              Experience
            </Nav.Link>
            <Nav.Link className="navbar-others" href="#projects">
              Projects
            </Nav.Link>
            <Nav.Link className="navbar-others" href="#contact">
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default Navigation;
